export const ROLE_SUPERADMIN = "superadmin";
export const ROLE_ADMIN = "admin";
export const ROLE_QUESTION_EDITOR = "question_editor";

const ROLE_ALIAS_MAP = {
  superadmin: ROLE_SUPERADMIN,
  super_admin: ROLE_SUPERADMIN,
  admin: ROLE_ADMIN,
  question_editor: ROLE_QUESTION_EDITOR,
  questioneditor: ROLE_QUESTION_EDITOR,
  standard: ROLE_QUESTION_EDITOR,
};

export const ROLE_OPTIONS = [
  { value: ROLE_SUPERADMIN, label: "Super Admin" },
  { value: ROLE_ADMIN, label: "Admin" },
  { value: ROLE_QUESTION_EDITOR, label: "Question Editor" },
];

export const ROLE_VALIDATION_MESSAGE =
  "Role must be one of: superadmin, admin, question_editor";

export const normalizeRole = (roleValue) => {
  const normalized = String(roleValue || "").trim().toLowerCase();
  return ROLE_ALIAS_MAP[normalized] || "";
};

export const isValidRole = (roleValue) => Boolean(normalizeRole(roleValue));

export const getRoleLabel = (roleValue) => {
  const normalized = normalizeRole(roleValue);
  const option = ROLE_OPTIONS.find((role) => role.value === normalized);
  return option ? option.label : String(roleValue || "");
};

export const getDefaultAdminPath = (roleValue) => {
  const normalized = normalizeRole(roleValue);
  return normalized === ROLE_QUESTION_EDITOR
    ? "/admin/questions"
    : "/admin/dashboard";
};
